module.exports = __webpack_public_path__ + "static/assets/83bea64a7a91dd3527f999f19ad18762.png";